import classNames from 'classnames';
import React from 'react';
import styles from './index.module.scss'
import { Row, Col, Form, Input, Button, DatePicker, message, Spin } from 'antd';
import { useEffect, useState } from 'react';
import UploadImg from './UploadImg';
import ContentForm from './ContentForm';
import { fileUpload } from "@/apis/public";
import { courseCreate, courseDetail, courseUpdate } from '@/apis/course';
import { useNavigate } from 'react-router-dom';
import { useSearchParams } from 'react-router-dom';
import moment from 'moment';
import intl from 'react-intl-universal';

const CourseAddOrEdit = () => {
	const [form] = Form.useForm();
	let [searchParams] = useSearchParams();
	const courseUuid = searchParams.get('id');
	const [coverFile, setCoverFile] = useState([]);// 封面图片

	const [img_id, setImg_id] = useState("");// 图片id--编辑
	const [imgPath, setImgPath] = useState("");// 图片路径--编辑

	const [loading, setLoading] = useState(false)
	const navigate = useNavigate();

	const getDetail = () => {
		courseDetail({
			courseUuid: courseUuid
		}).then(res => {
			const result = res?.data || {}
			form.setFieldsValue({
				courseName: result?.courseName,
				teacherName: result?.teacherName,
				description: result?.description,
				courseItems: (result?.courseItems || []).map(item1 => {
					return {
						subCourseName: item1.subCourseName,
						date: [moment(item1.startTime), moment(item1.endTime)],
						courseMaterials: (item1.courseMaterials || []).map(item2 => {
							return {
								materialDescription: item2.materialDescription,
								resourceUuid: item2.resourceUuid
							}
						})
					}
				}),
				courseAvailableTime: moment(result?.courseAvailableTime),
				coverFile: "file",
			})
			setImg_id(result?.coverImage?.fileUuid)
			setImgPath(result?.coverImage?.filePath)
		})
	}

	useEffect(() => {
		if (courseUuid) {
			getDetail()
		} else {
			// form.setFieldValue('newsType', "Open Resource News")
		}
	}, [courseUuid])

	useEffect(() => {
		if (!img_id) {
			form.setFieldValue('coverFile', "")
		}
	}, [img_id])

	const uploadFile = (list) => {
		return new Promise((resolve, reject) => {
			if (list.length > 0) {
				const formData = new FormData()
				formData.append("multipartFiles", list[0].xhr)
				formData.append("secondType", "Course")
				fileUpload(formData).then(res => {
					const fileUuids = res?.data[0]?.fileUuid || ''
					resolve(fileUuids)
				}).catch(err => {
					return false
				})
			} else {
				resolve("")
			}
		})
	}

	const onFinish = (values) => {
		setLoading(true)
		// 先上传文件
		Promise.all(
			[uploadFile(coverFile)]
		).then((res) => {
			const params = {
				courseName: values.courseName,
				teacherName: values.teacherName,
				courseAvailableTime: values.courseAvailableTime.format('YYYY-MM-DD'),
				description: values.description,
				courseItems: values.courseItems.map(item1 => {
					return {
						subCourseName: item1.subCourseName,
						startTime: item1.date[0].format('YYYY-MM-DD HH:mm'),
						endTime: item1.date[1].format('YYYY-MM-DD HH:mm'),
						courseMaterials: item1.courseMaterials.map(item2 => {
							return {
								materialDescription: item2.materialDescription,
								resourceUuid: item2.resourceUuid
							}
						})
					}
				}),
			}
			if (courseUuid) {
				// 编辑  有新的图片资源用新的 没有则用旧的图片资源id
				params.courseUuid = courseUuid
				params.coverImageUuid = res[0] || img_id
				edit(params)
			} else {
				params.coverImageUuid = res[0]
				add(params)
			}
		})
	}

	const add = (params) => {
		courseCreate(params).then(res => {
			setLoading(false)
			message.success('新增成功')
			navigate('/discover/my-course')
			window.scrollTo(0, 0);
		}).catch(err => {
			setLoading(false)
		})
	}

	const edit = (params) => {
		courseUpdate(params).then(res => {
			setLoading(false)
			message.success('修改成功')
			navigate('/discover/my-course')
		}).catch(err => {
			setLoading(false)
		})
	}
	useEffect(() => {
		if (coverFile.length > 0) {
			form.setFieldValue('coverFile', "file")
			form.validateFields(['coverFile'])
		} else {
			form.setFieldValue('coverFile', "")
		}
	}, [coverFile])

	const msg = intl.get("Please complete this required field")
	return <Spin spinning={loading}>
		<div className={classNames('container', styles.addNewsBox)}>
			<h3>{intl.get("Course.Course information")}</h3>
			<Form name="basic"
				onFinish={onFinish}
				autoComplete="off"
				labelCol={{ flex: "160px" }}
				form={form}
				initialValues={{
					courseItems: [{
						subCourseName: '',
						date: "",
						courseMaterials: [
							{
								materialDescription: '',
								resourceUuid: '',
							},
						],
					}],
				}}
				variant="filled">
				<Row gutter={80}>
					<Col span={12}>
						<Form.Item
							label={intl.get("Course.Name of course")}
							name="courseName"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Input />
						</Form.Item>
						<Form.Item
							label={intl.get("Course.Course teachers")}
							name="teacherName"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Input />
						</Form.Item>
						<Form.Item
							label={intl.get("Course.School hours")}
							name="courseAvailableTime"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<DatePicker
								format="YYYY-MM-DD"
								style={{ width: "100%" }}
							/>
						</Form.Item>
						<Form.Item
							label={intl.get("Course.Course description")}
							name="description"
							rules={[
								{
									required: true,
									message: msg
								},
							]}
						>
							<Input.TextArea rows={4} />
						</Form.Item>
						<Form.Item
							label={intl.get("Course.Course cover")}
							name="coverFile"
							rules={[
								{
									required: true,
									message: msg,
								},
							]}
						>
							<UploadImg fileList={coverFile} setFileList={setCoverFile} imgPath={imgPath} setImgPath={setImgPath} setImg_id={setImg_id} />
						</Form.Item>
					</Col>
					<Col span={12}>
						<ContentForm msg={msg} />
					</Col>
				</Row>
				<Form.Item>
					<Button type="primary" htmlType="submit">{intl.get("Share.Submit")}</Button>
				</Form.Item>
			</Form>

		</div>;
	</Spin>
}
export default CourseAddOrEdit;